import { useSnowballSync } from './useSnowballSync';

/**
 * Zero-UI monitor component that runs the background sync hook.
 * for the lifetime of the app. Mount once inside UserProvider (which is
 * already nested inside ContactStateProvider).
 */
const SnowballSyncMonitor: React.FC = () => {
  useSnowballSync();
  return null;
};

export default SnowballSyncMonitor;
